export default {
    changeBind(ctx,isbind){
        ctx.commit('changeBind',isbind);
    },
    changeName(ctx,name){
        ctx.commit('changeName',name);
    },
    changeStuNumber(ctx,stunumber){
        ctx.commit('changeStuNumber',stunumber);
    },
    changePhone(ctx,phone){
        ctx.commit('changePhone',phone);
    },
    changeMajor(ctx,major){
        ctx.commit('changeMajor',major);
    },
    changeOpen_id(ctx,openId){
        ctx.commit('changeOpen_id',openId);
    },
    changeNickname(ctx,nickname){
        ctx.commit('changeNickname',nickname);
    },
    changeHeadImgUrl(ctx,headImgUrl){
        ctx.commit('changeHeadImgUrl',headImgUrl);
    },

}


//////////////////
// WEBPACK FOOTER
// ./store/actions.js
// module id = null
// module chunks = 